export default __webpack_public_path__ + "static/media/document-icon.74be1ed0.svg";